import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';

@JsonObject('model.project.ItemDetail')
export class ItemRef extends AbstractModel {

    @JsonProperty(String, 'name')
    name?: string;

    @JsonProperty(String, 'value')
    value?: string;

}
